<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--sm mb-5">Criar Ticket Instalação</h1>
    <FormularioTicketInstalacaoComponent

      :tipoFormulario="tipoFormulario"
      :ticket="ticket"
    />
  </div>
</template>

<script>
import moduleReload from '@/common/mixins/module-reload.js'
import FormularioTicketInstalacaoComponent from '../components/FormularioTicketInstalacaoComponent.vue'

export default {
  name: 'TicketInstalacaoPage',
  mixins: [moduleReload],
  components: { FormularioTicketInstalacaoComponent },

  data () {
    return {
      tipoFormulario: 'salvar',
      ticket: {}
    }
  },

  methods: {
    reloadData() {
      this.$router.push({ name: 'dashboard' });
    }
  }
}
</script>
